import * as reducers from "../reducers";
import thunk from "redux-thunk";
import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import { createLogger } from "redux-logger";
import { addBreadcrumb } from "@sentry/react";

const middleware = [thunk];

if (__DEV__) {
	const logger = createLogger({
		duration: true,
		collapsed: true,
	});

	middleware.push(logger);
}

if (__ERROR_REPORTING__) {
	const sentryReporter = () => (next) => (action) => {
		addBreadcrumb({
			message: action.type,
			category: "redux",
		});

		return next(action);
	};

	middleware.push(sentryReporter);
}

const reducer = combineReducers(reducers);

// The composeEnhancers creates a store enhancer that enables the use of the Redux DevTools extension
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducer, {}, composeEnhancers(applyMiddleware(...middleware)));

export default store;
